export default {
  active: true,
  address: '',
  addressApt: '',
  addressNumber: '',
  birthdate: '',
  careerIds: [],
  careers: [],
  civilState: '',
  collaborator: true,
  communeId: '',
  communeName: '',
  company: {},
  companyId: '',
  correlativeIdentification: '',
  countryId: '',
  educationLevel: '',
  email: '',
  emergencyContactCountryCode: '+56',
  emergencyContactName: '',
  emergencyContactPhone: '',
  emergencyContactRelation: '',
  employeeCard: {
    fileInfo: {}
  },
  fileInfo: {},
  firstLastName: '',
  fullName: '',
  genderId: '',
  id: '',
  identificationType: '',
  languageIds: [],
  languages: [],
  name: '',
  nationalIdExpirationDate: '',
  phone: '',
  phoneCountryCode: '+56',
  postTitle: '',
  profileIds: [],
  profiles: [],
  secondLastName: '',
  senceLevel: '',
  signSubstituteId: '',
  singSubstitute: {},
  userId: '',
  workEmail: '',
  workPhone: '',
  workPhoneCountryCode: '+56',
  contract: {
    acumulativeAdditionalHolidays: false,
    additionalHolidays: '',
    additionalHolidaysStartDate: '',
    administrativeDays: '',
    bankAccount: '',
    bankAccountType: '',
    bankId: '',
    branchOfficeId: '',
    checkAssistance: false,
    contractBalancesAttributes: [],
    contractType: '',
    costCenterId: '',
    disability: false,
    disabilityCertificate: {},
    disabilityFileInfo: {},
    disabilityNationalIdentification: '',
    documentTemplateId: '',
    employerSalary: false,
    endDate: '',
    friday: false,
    gratificationCondition: '',
    gratificationPeriod: '',
    gratificationType: '',
    jacketSize: '',
    jobManagementId: '',
    jobTitleId: '',
    law19010: false,
    law19966: false,
    markingType: '',
    monday: false,
    outSourced: false,
    outSourceAddress: '',
    outSourceAddressFlat: '',
    outSourceAddressNumber: '',
    outSourceAddressOffice: '',
    outSourceBusinessName: '',
    outSourceCommuneId: '',
    outSourceEstablishmentName: '',
    outSourceExceptionalSystem: false,
    outSourceExceptionalSystemNumber: '',
    outSourceNationalIdentification: '',
    outSourceRegionId: '',
    pantsSize: '',
    parentId: '',
    payFirstLicenseDays: false,
    paymentSchedule: '',
    paymentType: '',
    presenceCheckAssistance: false,
    progressiveFileInfo: {},
    progressiveVacationsCertificate: {},
    recognizedMonths: '',
    recognizedMonthsFrom: '',
    salary: '',
    salaryWithLicense: false,
    saturday: false,
    senceFranchise: '',
    shiftIds: [],
    shirtSize: '',
    shoesSize: '',
    startDate: '',
    sunday: false,
    syndicateId: '',
    tShirtSize: '',
    thursday: false,
    tuesday: false,
    wednesday: false,
    weeklyHours: '',
    workEndTime: '18:00',
    workSchedule: '',
    workStartTime: '09:00',
    workerQuality: '',
    employeePrevisionAttributes: {
      agreedQuantity: '0',
      firstAgreedAmount: '0',
      secondAgreedAmount: '0',
      familyAllowanceSection: 'no_family_allowance',
      healthPrevisionId: '',
      heavyLaborAdditional: 'no_heavy_labor',
      ineCode: '',
      ipsType: '',
      pensionFundId: '',
      pensionScheme: '',
      pensionSchemeRate: '',
      pensioner: '',
      unemploymentInsurance: true,
      unemploymentInsuranceReason: '',
      unitOfAccount: '',
      voluntaryPrevisionsAttributes: [],
      youthAllowance: false
    }
  },
  employeeCertificationsAttributes: [],
  familyGroupsAttributes: []
};
